export default {
  methods: {
    hasSlot (key) {
      return this.$slots?.[key]
    }
  }
}
